import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/organizations/holes'

export default class HoleControllerServiceOrganization {
    static async save(detailId, data) {
        return await axios.post(`${detailControllerRestUrl}?detailId=${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(holeId) {
        return await axios.delete(`${detailControllerRestUrl}/${holeId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async put(holeId, data) {
        return await axios.put(`${detailControllerRestUrl}/${holeId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
